export default {
  getLiveLocal: (state) => (tcmId) => {
    return state.liveLocal[tcmId]
  },
  getLiveLocalCategories: (state) => (tcmId) => {
    return state.livelocalCategories
  }
}
